import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';

export const BannerWrapper = styled.div`
  margin-top: ${sizes.medium};
`;
